import type { Unsubscribe } from '@amazon/vinyl-util'
import { createDisposer, logDebug, noop } from '@amazon/vinyl-util'
import { getAuth } from '@/auth/authRef'
import { cleanCache, getCacheManager } from '@/core/offlineCacheManager'
import { ctx } from '@/util/context'
import { AuthStatus } from '@amzn/amp-playback'
import { noCache } from '@/core/noCache'

const { target, errorHandler } = ctx('offline')

export const cacheEnabled = !noCache

export function initializeOfflineCache(): Unsubscribe {
    const { add, dispose } = createDisposer()
    const cacheManager = getCacheManager()
    if (cacheEnabled) {
        logDebug(target, 'caching enabled')
    } else {
        logDebug(target, 'clearing offline cache...')
        cacheManager.clear().catch(noop)
    }

    setTimeout(() => {
        // Purge the stale items from the cache, but not while the app is starting.
        cleanCache().catch(errorHandler)
    }, 5 * 1000)

    add(
        getAuth().status.onData((_, previousValue) => {
            // The customer signed out, clear all offline cache data.
            if (previousValue === AuthStatus.SIGNED_IN) {
                logDebug(target, 'clearing cache after sign-out')
                // User has changed; cached queries should be cleared.
                cacheManager.clear().catch(errorHandler)
            }
        })
    )

    return dispose
}
